import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const restoreScheduledRide = async (scheduledRideId: number) => {
  const response = await mutationExecute({
    variables: {
      scheduledRideId,
    },
    mutation: graphql(`
      mutation RestoreScheduledRide($scheduledRideId: Float!) {
        restoreScheduledRide(scheduledRideId: $scheduledRideId)
      }
    `),
  });

  return response.data?.restoreScheduledRide ?? false;
};
